export default "__VITE_ASSET__c88a08d9__"